<template>
  <div>
    <Header @mlogin="mlogin" @scrollTo="scrollTo" :visible_brand="visible_brand" :visible_type="visible_type"
      @mlogin_clean="mlogin_clean"></Header>
    <div id="index_banner" class="index_banner" v-if="showType==0">
      <div class="index_banner_title">星云创意——企业级·创意内容采购解决方案</div>
      <div class="index_banner_content">
        <div class="index_banner_left">
          <div v-if="isCase" class="index_banner_left_case_1">
            <div class="index_banner_left_case_1_title">提交需求</div>
            <el-select placeholder="请选择创意服务" class="index_banner_left_case_1_select" v-model="service_code">
              <el-option v-for="(item,index) in service_dicts" :label="item.name" :value="item.code"
                :key="index"></el-option>

            </el-select>
            <el-button type="primary" @click="submitNeed" class="index_banner_left_case_1_submit_btn">提交创意需求</el-button>
            <div class="index_banner_left_case_1_tip">
              5秒 <span>提交需求 ></span> 30分钟 <span>响应 ></span> 12小时
              <span>开始服务</span>
            </div>
          </div>
          <div v-else class="index_banner_left_case_2">
            <div class="index_banner_left_case_2_breadcrumb" @click="isCase = !isCase">
              <img alt="" :src="require('@/assets/img/icon_left.png')" />
              返回修改
            </div>
            <div class="index_banner_left_case_2_text1">
              请确认您要找的创意服务：战役主视觉KV
            </div>
            <div class="index_banner_left_case_2_text2">
              根据您预留的手机号将会有负责人与您联络，请保持电话畅通
            </div>
            <div class="index_banner_left_case_2_phone_input">
              <el-input placeholder="请输入您的手机号" v-model.trim="telphone" maxLength="15" @input="toNumberTel" />
            </div>
            <div style="margin-top: 12px;">
              <SlideVerify
                ref="slideVerifyIndex"
                width="100%"
                @passed="onSlidePassed"
                challengeUrl="/stapi/site/slide-challenge"
                challengeMethod="get"
                verifyUrl="/stapi/site/slide-verify"
                :verifyExtraParams="{ sys_type: 'biginhouse' }"
                :includePointsJson="false"
              />
            </div>
            <div class="index_banner_left_case_2_code_input_wrap">
              <div class="index_banner_left_case_2_code_input">
                <el-input placeholder="请输入验证码" v-model.trim="yzm" maxLength="6" @input="toNumberYzm" />
              </div>
              <button class="index_banner_left_case_2_code_btn" @click="getyzm" :disabled="disabled">
                {{titlename}}
              </button>
            </div>

            <el-button type="primary" class="index_banner_left_case_1_submit_btn" @click="submitForm"
              :disabled="sub_disabled">确认提交需求并获取报价</el-button>
          </div>
        </div>
        <div class="index_banner_right_left_video" v-if="false">
          <img v-show="!isVideo" class="index_banner_right_left_video_img" :src="require('@/assets/img/img_video.png')"/>
          <img @click="isVideo = true" v-show="!isVideo" class="index_banner_right_left_video_play"
             :src="require('@/assets/img/icon_play.png')"/>
          <video v-if="isVideo" autoplay controls class="index_banner_right_left_video_tag"
           :src="require('@/assets/img/disseminate.mp4')"></video>
        </div>
        <div class="index_banner_right">
          <div class="index_banner_right_title">
            一站式解决创意内容生产需求：
          </div>
          <div class="index_banner_right_item">
            <div class="index_banner_right_item_text1">高质量服务水平</div>
            <div class="index_banner_right_item_text2">
              严选优质服务团队+项目经理1V1全程管理，省心省力获得好创意
            </div>
          </div>
          <div class="index_banner_right_item">
            <div class="index_banner_right_item_text1">透明化低价保证</div>
            <div class="index_banner_right_item_text2">
              AIGC人机结合，成本直降50%+，底价直达眼前
            </div>
          </div>
          <div class="index_banner_right_item">
            <div class="index_banner_right_item_text1">多元化服务供给</div>
            <div class="index_banner_right_item_text2">
              <span class="mark_blue">100+</span>创意服务类型；<span class="mark_blue">1000+</span>专业团队；<span
                class="mark_blue">10000+</span>优秀案例
            </div>
          </div>
          <div class="index_banner_right_item">
            <div class="index_banner_right_item_text1">高产能效率提升</div>
            <div class="index_banner_right_item_text2">
              AIGC赋能传统创意内容，让周付100张海报变为可能
            </div>
          </div>
        </div>
      </div>
    </div>
    <section id="index_section_service" class="section_service" v-if="showType==0">
      <p class="section_title">服务有保障——全流程把控，确保交付质量稳定性</p>
      <div class="card" v-for="(serviceItem,index) in serviceInfo" :key="index">
        <img :class="serviceItem.imgClass" :src="serviceItem.src" />
        <article>
          <span class="article_title">{{serviceItem.title}}</span>
          <div class="detail_list">
            <p v-for="(text,index) in serviceItem.list" :key="index">{{text}}</p>
          </div>
        </article>
      </div>
    </section>
    <section id="index_category" class="category" v-if="showType==0">
      <p class="section_title">类目全——上百种创意服务类目</p>
      <div class="category_list">
        <div class="category_card" v-for="(categoryItem,index) in categoryInfo" :key="index">
          <img :src="categoryItem.src" />
          <p class="category_card_title">{{categoryItem.title}}</p>
          <p>{{categoryItem.desc}}</p>
        </div>
      </div>
    </section>
    <section id="index_group" class="group" v-if="showType==0">
      <p class="section_title">团队多——上千家专业团队，上万个优秀案例</p>
      <div class="button" style="margin-top: 8px" @click="mlogin('example')">更多案例</div>
      <div class="group_list">
        <div class="group_card" v-for="(groupItem,index) in groupInfo" :key="index" @click="goDetail(groupItem)">
          <img :src="groupItem.annex_url" />
          <div class="group_info">
            <p class="group_card_title">{{groupItem.name}}</p>
            <p>
              <span class="group_card_type">{{groupItem.category_top_name}}</span>
              <span>{{groupItem.category_second_name}}</span>
            </p>
            <p class="source">{{groupItem.company}}</p>
          </div>
          <div class="hover_box">
            <p>创意团队：{{groupItem.company}}</p>
            <p>团队规模：{{groupItem.team_size}}&nbsp;&nbsp;&nbsp;&nbsp;所在地：{{groupItem.regional_scope == 2 ? groupItem.area
              : (groupItem.area != "" && groupItem.regional_scope == 1 ? getNameByCode(groupItem.area) : '')}} </p>
            <!-- <p>客户评分：{{groupItem.score || 0}}</p> -->
            <p class="multi_text1 multi_text2">擅长行业：{{groupItem.good_at_top_industry}}</p>
            <p class="multi_text3 multi_text2">擅长业务领域：{{groupItem.good_at_top_category}}</p>
            <p class="multi_text1 multi_text2">服务过的客户：{{groupItem.service_brand}}</p>
            <!--            <p  class="multi_text1">资源优势：{{groupItem.resource || ''}}</p>-->
          </div>
        </div>
      </div>
    </section>
    <section id="index_process" class="process" v-if="showType==0">
      <p class="section_title">服务流程</p>
      <div class="process_list">
        <div style="display: flex" v-for="(progressItem, index) in progressInfo" :key="index">
          <div class="progressItem">
            <div class="progressTop">
              <img :src="progressItem.src" />
              <span class="title">{{progressItem.title}}</span>
            </div>
            <p class="desc">{{progressItem.desc}}</p>
          </div>
          <img class="next_img" v-if="index !== progressInfo.length - 1"
            :src="require('@/assets/img/home_icon_sp_right@2x.png')" />
        </div>
      </div>
    </section>
    <section id="index_customer" class="customer" v-if="showType==0">
      <p class="section_title" style="margin-bottom: 64px">客户评价</p>
      <div class="customer_list">
        <div v-for="(customerItem,index) in customerInfo" class="customer_card" :key="index">
          <div class="top">
            <img :src="customerItem.avatar" class="avatar" />
            <div>
              <p class="name">{{customerItem.name}}</p>
              <p class="company">{{customerItem.company}}</p>
            </div>
          </div>
          <p class="desc">{{customerItem.desc}}</p>
        </div>
      </div>
    </section>
    <Ewm :service_dicts="service_dicts" @showBox="showBox" ></Ewm>
    <Reg id="index_reg" v-if="showType==1"></Reg>
    <RegServer id="index_regserver" v-if="showType==2"></RegServer>
    <Common :visible="visible" :visible2="visible2" :visible3="visible3" @mlogin_clean="mlogin_clean"></Common>
    <Footer @mlogin="mlogin"></Footer>
  </div>
</template>
<script>
/* eslint-disable */
  import Header from '@/components/Header.vue'
  import Ewm from '@/components/Ewm.vue'
  import Footer from '@/components/Footer.vue'
  import Common from '@/components/Common.vue'
  import Reg from '@/components/Reg.vue'
  import RegServer from '@/components/RegServer.vue'
  import SlideVerify from "@/components/SlideVerify.vue"
  import axios from "axios"
  import * as commfun from "@/common/common.js"
  import index_mixins_shengshi from "@/common/mixins/index_mixins_shengshi.js"
  export default {
    name: 'Index',
    mixins: [index_mixins_shengshi],
    components: {
      Header,
      Ewm,
      Footer,
      Common,
      Reg,
      RegServer,
      SlideVerify
    },
    data: function () {
      return {
        visible: false,
        visible2: false,
        visible3: false,
        visible_brand: false,
        visible_type: '',
        sub_disabled: false, //disable submit
        selectValue: "",
        input1: "",
        input2: "",
        isCase: true,
        showType: 0,//0显示首页 1显示注册需求方 2显示服务方
        serviceInfo: [
          {
            title: "专属项目经理执行团队",
            src: require('@/assets/img/illustrator1@2x.png'),
            imgClass: "card_pic1",
            list: [
              "平台自有专业项目经理团队，1V1全力支持项目运行",
              "项目经理参与项目全链路把控管理及供需方沟通协调，确保交付质量",
              "每个KA客户配备固定项目经理服务，沉淀专属的品牌服务经验",
            ],
          },
          {
            title: "专业创意服务团队",
            src: require('@/assets/img/illustrator2@2x.png'),
            imgClass: "card_pic2",
            list: [
              "高标准团队入驻门槛，优选服务团队资源",
              "严格筛选审核创意服务团队资质的真实性",
              "动态评分机制，快速更新迭代服务团队质量水平",
            ],
          },
        ],
        categoryInfo: [
          {
            title: "视觉创意",
            desc: "设计/视频/网页/互动开发等",
            src: require('@/assets/img/home_sjcy.png'),
          },
          {
            title: "线下活动营销",
            desc: "线下活动、快闪店、POSM等",
            src: require('@/assets/img/home_xxhdyx.png'),
          },
          {
            title: "新媒体代运营",
            desc: "双微、小红书、抖音、视频号等",
            src: require('@/assets/img/home_xmtdyy.png'),
          },
          {
            title: "电商战役",
            desc: "详情页、产品头图等",
            src: require('@/assets/img/home_dszy.png'),
          },
          {
            title: "公关服务",
            desc: "舆情公关、SEO等",
            src: require('@/assets/img/home_ggfw.png'),
          },
          {
            title: "整合营销",
            desc: "创意策划、执行管理等",
            src: require('@/assets/img/home_zhyx.png'),
          },
          // {
          //   title: "网页、移动端设计/开发",
          //   desc: "网页、H5、小程序等创意设计、开发",
          //   src: require('@/assets/img/home_icon_web@2x.png'),
          // },

          // {
          //   title: "创意策划",
          //   desc: "支持全行业创意方案、文案输出",
          //   src: require('@/assets/img/home_icon_create@2x.png'),
          // },
        ],
        // 优秀/热门案例
        groupInfo: [],
        progressInfo: [
          {
            title: "发布需求",
            desc: "上百种创意服务\n5秒发布需求",
            src: require('@/assets/img/home_icon_sp_release@2x.png'),
          },
          {
            title: "平台响应",
            desc: "30分钟内平台响应\n接收需求",
            src: require('@/assets/img/home_icon_sp_platform@2x.png'),
          },
          {
            title: "需求沟通",
            desc: "项目经理1V1跟进\n3小时完成沟通确认",
            src: require('@/assets/img/home_icon_sp_communication@2x.png'),
          },
          {
            title: "项目执行",
            desc: "项目经理全程监督\n12小时内启动项目",
            src: require('@/assets/img/home_icon_sp_project@2x.png'),
          },
          {
            title: "产出交付",
            desc: "规定时间内\n高质量交付客户",
            src: require('@/assets/img/home_icon_sp_product@2x.png'),
          },
        ],
        customerInfo: [
          {
            avatar: require('@/assets/img/p1.png'),
            name: "采购-Vince",
            company: "某快消公司",
            desc: "一个big idea+一条TVC打天下的时代已经过去了，现在的营销内容越来越碎片化，营销趋势也日新月异，需求越来越多样；平台化的供给打破了传统单一广告公司人力有限、精力有限、服务类型有限的壁垒，为我们节省了很多寻源的时间和精力。",
          },
          {
            avatar: require('@/assets/img/p2.png'),
            name: "设计部-Tyana",
            company: "某食品公司",
            desc: "这里有很多出色的创意团队，我可以通过他们的案例选择自己喜欢的团队，一开始也担心产出不能符合我们的要求，但合作后发现虽然团队规模都不是很大，但是能力也都很优秀，价格还不贵，简直是给我装了好多外挂~",
          },
          {
            avatar: require('@/assets/img/p3.png'),
            name: "市场部-Jan",
            company: "某互联网公司",
            desc: "很多大型的广告公司不接这种碎片化的内容需求，自己找小公司吧又不知道资质靠不靠谱，通过平台寻源正好解决了这些烦恼，合作了几次，每次合作的团队都是经过严格筛选，项目经理也非常负责地全程跟进，交付很稳定。",
          },
        ],
        service_dicts: [
          {
            code: 101,
            name: '海报/KV'
          },
          {
            code: 102,
            name: '电商设计'
          },
          {
            code: 103,
            name: '品牌/宣传'
          },
          {
            code: 104,
            name: '包装/周边'
          },
          {
            code: 105,
            name: '视频/短视频'
          },
          {
            code: 106,
            name: '动画'
          },
          {
            code: 107,
            name: '网页、移动端设计/开发'
          },
          {
            code: 108,
            name: '创意策划'
          }
        ],
        year: new Date().getFullYear(),
        contactModalVisible: false,
        second: '', // 倒计时秒
        disabled: false, //倒计时停用按钮
        timer: null, //计时器
        service_code: '', // 创意服务code
        telphone: '', // 手机号码
        yzm: '', //验证码
        slidePassed: false,
        slideToken: '',
        isVideo: false,
        serviceModal: false,

      };
    },
    mounted() {
      //省市数据加载
      this.getShengShi();
      this.initHotList()
    },
    computed: {
      titlename() {
        return this.disabled ? this.second + "s" : '获取验证码';
      }
    },
    methods: {
      onSlidePassed (token) {
        this.slidePassed = true
        this.slideToken = token
      },

      mlogin: function (type) {
        if (type == 'example') {
          this.visible = true
        } else if (type == 'brand') {
          this.visible_brand = true
          this.visible_type = 'brand'
        } else if (type == 'service') {
          this.visible_brand = true
          this.visible_type = 'server'
        } else if (type == 'noaccount') { //无账号
          this.visible_brand = false
          //this.visible2 = true
          if (this.visible_type == 'brand') { //需求方注册
            this.showType = 1
            this.scrollToReg("index_reg");
          } else if (this.visible_type == 'server') {//服务方注册
            this.showType = 2
            this.scrollToReg("index_regserver")
          }
        } else if (type == 'need') { //需求方注册
          this.showType = 1
          this.scrollToReg("index_reg");
        } else if (type == 'input') {//服务方注册
          this.showType = 2
          this.scrollToReg("index_regserver")
        } else {
          this.visible2 = true
        }

      },
      mlogin_clean: function (type) {
        if (type == 'brand' || type == 'service') {
          this.visible_brand = false
          this.visible_type = ''
        } else {
          this.visible = false
          this.visible2 = false
          this.visible3 = false
          this.visible_brand = false
        }

      },
      toNumberTel: function (value) {
        // console.log(value)
        var selfthis = this
        commfun.numMaxLength(value, 15, function (item) {
          selfthis.telphone = item
        })
      },
      toNumberYzm: function (value) {
        // console.log(value)
        var selfthis = this
        commfun.numMaxLength(value, 6, function (item) {
          selfthis.yzm = item
        })
      },
      getyzm: function () {
        let selfthis = this
        if (!this.telphone) {
          commfun.showMessage(selfthis, 'warning', '请输入手机号码!')
          return false;
        }
        if (!selfthis.slidePassed) {
          commfun.showMessage(selfthis, 'warning', '请先完成滑动验证')
          return false;
        }
        if (!selfthis.slideToken) {
          commfun.showMessage(selfthis, 'warning', '滑块凭证异常，请刷新重试')
          return false;
        }
        // 倒计时 控制start
        let s = 30 // 倒计时
        if (!selfthis.timer) {
          console.log('--start--')
          selfthis.second = s
          selfthis.disabled = true
          selfthis.timer = setInterval(() => {
            if (selfthis.second > 0 && selfthis.second <= s) {
              selfthis.second--
            } else {
              selfthis.disabled = false
              clearInterval(selfthis.timer)
              selfthis.timer = null
            }
          }, 1000)
        }
        // 倒计时 控制end
        // console.log("to api")
        selfthis.sendSms();
      },
      sendSms: function () {
        var selfthis = this
        var url = "/stapi/site/sendsms2"
        const form = new URLSearchParams()
        form.append('phone', this.telphone || '')
        form.append('sys_type', 'biginhouse')
        form.append('type', 'index_inhouse')
        form.append('slide_token', this.slideToken || '')
        axios.post(url, form, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' }
        }).then(
            (response) => {
              var data = response.data
              console.log("请求成功", data)
              if (data.code == '200') {
                commfun.showMessage(selfthis, 'success', "成功：" + "短信发送成功")
              } else {
                selfthis.disabled = false
                clearInterval(selfthis.timer)
                selfthis.timer = null
                commfun.showMessage(selfthis, 'warning', "信息提交异常：" + data.msg)
              }

            },
            (error) => {
              console.log("请求失败", error.message)
              commfun.showMessage(selfthis, 'warning', "错误：网络失败")
            }
        );//axios end

      },
      submitForm: function () {
        var selfthis = this
        var url = "/stapi/site/xingyun-add"
        var service_name = this.getServiceName(this.service_code);
        var data1 = {
          service_code: this.service_code,
          service_name: service_name,
          telphone: this.telphone,
          telVerifyCode: this.yzm
        }
        if (!data1.service_code) {
          selfthis.showBox('warning', '请选择创意服务!');
          return false;
        }
        if (!data1.telphone) {
          selfthis.showBox('warning', '请输入手机号码!');
          return false;
        }
        if (!data1.telVerifyCode) {
          selfthis.showBox('warning', '请输入验证码!');
          return false;
        }
        selfthis.sub_disabled = true
        axios.post(url, data1, { headers: { 'Content-type': 'application/x-www-form-urlencoded;charset=utf-8' } }).then(
            (response) => {
              selfthis.sub_disabled = false
              var data = response.data
              // console.log("请求成功",data)
              if (data.code == '200') {
                selfthis.visible3 = true
                selfthis.second = 0
                selfthis.telphone = ''
                selfthis.yzm = ''
              } else {
                commfun.showMessage(selfthis, 'warning', "信息提交异常：" + data.msg)
              }
            },
            (error) => {
              selfthis.sub_disabled = false
              console.log("请求失败", error.message)
              commfun.showMessage(selfthis, 'warning', "错误：网络失败")
            }
        );
      },
      getServiceName: function (code) {
        var name = ''
        this.service_dicts.forEach(function (item, index) {
          if (code == item.code) {
            name = item.name
          }
        })
        return name;
      },

      showBox: function (type, msg) {
        this.$message({
          message: msg,
          type: type,
          offset: 200
        });
      },
      scrollTo: function (type) { //滚动到位置 锚点
        this.showIndex()
        setTimeout(function () {
          document.querySelector('#' + type).scrollIntoView(true)
        }, 100)

      },
      showIndex: function () {
        this.showType = 0
      },
      scrollToReg: function (type) { //滚动到位置 锚点
        setTimeout(function () {
          document.querySelector('#' + type).scrollIntoView(true)
        }, 100)

      },
      submitNeed: function () { //提交创意需求
        var selfthis = this
        if (this.service_code) {
          this.isCase = !this.isCase
        } else {
          selfthis.$message({
            message: '请先选择创意服务',
            type: 'warning',
            offset: 200
          });
        }
      },
      // 案例详情
      goDetail(item) {
        // 正常案例详情是需要登录的，所以这里使用的是分享的案例详情，需要先将案例ID加密，在获取地址访问
        var selfthis = this
        var url = "/api/api/demand/hotCaseDetail"
        commfun.ajaxPost(selfthis, url, { case_id: item.case_id }, function (selfthis, result) {
          window.open(result)
        }, function (selfthis, dataError) {
          commfun.showMessage(selfthis, 'warning', "错误：" + dataError.msg)
        })
      },
      // 热门案例数据
      initHotList: function () {
        var selfthis = this
        var url = "/api/api/demand/hotCase"
        commfun.ajaxPost(selfthis, url, {}, function (selfthis, data) {
          selfthis.groupInfo = data.data
        }, function (selfthis, dataError) {
          commfun.showMessage(selfthis, 'warning', "错误：" + dataError.msg)
        })
      },
      //toServiceCode 子向父床底数据
      toServiceCode: function(v){
        console.log("toServiceCode")
        this.service_code = v
      },
      toisCase_new: function(v){
        console.log("toisCase_new")
        this.isCase = v
      }


    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Index.vue